__turbopack_context__.v({
  "UiAlert": "alert-module__LqFKJW__UiAlert",
  "UiAlert__danger": "alert-module__LqFKJW__UiAlert__danger" + " " + "alert-module__LqFKJW__UiAlert",
  "UiAlert__icon": "alert-module__LqFKJW__UiAlert__icon",
  "UiAlert__info": "alert-module__LqFKJW__UiAlert__info" + " " + "alert-module__LqFKJW__UiAlert",
  "UiAlert__positive": "alert-module__LqFKJW__UiAlert__positive" + " " + "alert-module__LqFKJW__UiAlert",
});
